
<template>
  <el-dialog
    :title="getTitle"
    :visible.sync="value"
    width="50%"
    :before-close="handleCloseDailog"
    @open="handleOpenDailog"
  >
    <el-form
      ref="entityData"
      :model="entityData"
      :rules="rules"
      label-width="100px"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item
            label="留言"
            prop="applyMessage"
            style="width:100%"
          >
            <el-input
              v-model="entityData.applyMessage"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="handleCloseDailog">取 消</el-button>
      <el-button
        type="primary"
        @click="handleSaveData"
      >保  存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import pathReq from '@/api/pathlist'
import LoadingOptions from '@/components/commonSetting'
export default {
  components: {},
  props: {
    value: Boolean,
    entityId: { type: Number, default: null },
    friendUserId: { type: Number, default: null }
  },
  data() {
    return {
      title: '邀请好友',
      entityData: {},
      rules: {
        applyMessage: [
          { required: true, message: '请输入留言', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    getTitle() {
      return '邀请好友'
    }
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    handleOpenDailog() {},
    handleCloseDailog() {
      this.$emit('input', false)
    },
    handleSaveData() {
      this.$refs.entityData.validate(valid => {
        if (valid) {
          this.entityData.id = this.entityId
          this.entityData.friendUserId = this.friendUserId
          const loading = this.$loading(LoadingOptions.loadOptions)
          pathReq
            .postForm('/api/services/app/Contact/ApplyFriend', this.entityData)
            .then(() => {
              this.entityData = {}
              loading.close()
              this.$message.success(
                '已申请成为好友，对方通过后可以在好友面板查看到好友信息'
              )
              this.$emit('save-success')
              this.$emit('input', false)
            })
        } else {
          return false
        }
      })
    }
  }
}
</script>

